function spbc_admin_set_cookie(name, data, expires){
	var date = new Date(new Date().getTime() + 1000 * expires );
	document.cookie = name + '=' + data + '; path=/; expires=' + date.toUTCString();
}

jQuery(document).ready(function(){
	
	// Auto update banner close handler 
	jQuery('.spbc_update_notice').on('click', 'button', function(){
		spbc_admin_set_cookie('spbc_update_banner_closed', 1, 86400 * 30);
	});
	
});